import * as React from 'react';

import classnames from 'classnames';

import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import styles from './pause-page.module.css';

export function PauseRequestedPage() {
    const [nextBillDate, setNextBillDate] = React.useState<string>('');

    React.useEffect(() => {
        Nut.ajax.get({
            url: '/setup/billing/plan-preview.json',
            // @ts-expect-error
            success: (result) => {
                setNextBillDate(` on ${result.current.billDate.humanDate}`);
            },
        });
    }, []);

    return (
        <div className={classnames('pad-16', styles['pause-page'])}>
            <MarketingHeader>We’re processing your request</MarketingHeader>
            <div className={classnames('flex', styles.body)}>
                <div className={styles.copy}>
                    <MarketingBody>
                        {`You’ll be able to continue using your Nutshell account through the end of
                        your current billing cycle${nextBillDate}.`}
                    </MarketingBody>
                    <MarketingBody>
                        After that, we’ll bill you $4/month and securely store your data until
                        you’re ready to get back to business.
                    </MarketingBody>
                    <MarketingBody>
                        Our{' '}
                        <Link variant='primary' size='big' href='https://support.nutshell.com/'>
                            Ann Arbor team is here
                        </Link>{' '}
                        if you have any questions, and we’re all looking forward to a speedy
                        recovery.
                    </MarketingBody>
                </div>
                <Illustration src='timer' />
            </div>
        </div>
    );
}
